import { Component, type ReactNode } from 'react'
import { track } from '../analytics/track'
import { ErrorPage } from './ErrorPage'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  error: Error | null
}

/** Catches unexpected render/runtime errors that reportError() cannot cover. */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error) {
    console.error(error)
    track('error', { message: error.message, source: 'boundary' })
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorPage
          error={{ message: this.state.error.message || 'Unerwarteter Fehler in der Anwendung' }}
          onReset={() => this.setState({ error: null })}
        />
      )
    }
    return this.props.children
  }
}
